import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myAdvertsRoute: RouteConfig<'with-page'> = {
    name: 'My Adverts',
    path: '/adverts/my-adverts',
    page: lazy(() => import('.')),
    context: 'member',
    roles: ['ncassMember', 'accountManager'],
}
